import { useSignal } from "@preact/signals-react";

import { TimeControlIcon, NotesIcon } from "components/Icons/linear";
import MainMenu from "componentsv2/widgets/MainMenu";
import Layout from "components/Layout/ViewLayout";

const styleIcon =
  "relative size-[60px]  mx-auto my-3 stroke-1 group-hover:transition-all group-duration-300 ease-in-out group-hover:scale-110";

const view = [
  {
    name: "staff.assistance.control_title",
    desc: "staff.assistance.control_desc",
    link: "staff_assistance/assistance",
    Icon: <TimeControlIcon className={styleIcon} />,
    bg: "#DFF6E8",
  },
  {
    name: "staff.assistance.audit_title",
    desc: "staff.assistance.audit_desc",
    link: "staff_assistance/audit",
    Icon: <NotesIcon className={styleIcon} />,
    bg: "#CFEEFF",
  },
];

function StaffAssistance() {
  const currentView = useSignal(null);

  return (
    <Layout currentView={currentView} title="menu.staff_assistance">
      <MainMenu views={view} desc="staff.assistance.main_desc" columns={2} />
    </Layout>
  );
}

export default StaffAssistance;
